export default __webpack_public_path__ + "static/hotel-95159980-f05820485b8ebbeca5766caef2938833.png";